import { useState } from "react";
import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";

export default function FaqPage() {
  usePageMeta("常见问题 - 正版韩漫大全", "正版韩漫常见问题解答：如何识别正版渠道、正版与盗版区别、付费规则、韩漫分类等。");
  const [open, setOpen] = useState<number>(0);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  };

  return (
    <div className="bg-background-50">
      <div className="bg-primary-50/50">
        <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
          <nav className="text-xs text-foreground-500" aria-label="面包屑">
            <ol className="flex items-center gap-1.5">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-foreground-800" aria-current="page">常见问题</li>
            </ol>
          </nav>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-900 md:text-3xl">常见问题</h1>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            关于正版韩漫大全与正版韩漫阅读的常见疑问，点击问题即可查看答案。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-3xl px-4 py-10 md:px-6 md:py-14">
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <div key={f.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                aria-expanded={open === i}
              >
                <span className="text-sm font-medium text-foreground-900">{f.question}</span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                  <i className={`ri-add-line transition-transform ${open === i ? "rotate-45" : ""}`}></i>
                </span>
              </button>
              {open === i && (
                <div className="border-t border-background-200 px-5 py-4">
                  <p className="text-sm leading-relaxed text-foreground-600">{f.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 rounded-lg bg-background-100 p-8 text-center">
          <i className="ri-customer-service-2-line text-3xl text-primary-500"></i>
          <h2 className="font-heading text-lg font-bold text-foreground-900">还有其它问题？</h2>
          <p className="max-w-md text-sm text-foreground-600">欢迎联系我们，我们会尽快为你解答关于正版韩漫的疑问。</p>
          <Link
            to="/contact"
            className="mt-2 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            联系我们 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </div>
  );
}